import css from 'styled-jsx/css'
import { colors } from '../../../styles'

export default css`
.LoginDialog {
  max-width: 720px;
}

.title {
  font-size: 19px;
  color: ${colors.black};
  margin-bottom: 14px;
}

.subtitle {
  font-size: 16px;
  color: ${colors.darkPurple};
  margin-bottom: 24px;
}

.button-container {
  max-width: 300px;
  margin: 0 auto;
}

@media (min-width: 600px) {
  .title {
    font-size: 22px;
    margin-bottom: 16px;
  }
}

@media (min-width: 768px) {
  .title {
    font-size: 36px;
    margin-bottom: 18px;
  }
  .subtitle {
    font-size: 22px;
    margin-bottom: 32px;
  }
}

@media (min-width: 1024px) {
  .title {
    font-size: 46px;
    margin-bottom: 24px;
  }
  .subtitle {
    font-size: 27px;
    margin-bottom: 40px;
  }
}
.center {
  margin: 0px auto;
  padding: 3.5rem 0;
  text-align: center;
}
`
